// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { StoreProvider } from '../contexts/StoreContext';
import { DisplayPreferencesProvider, useDisplayPreferences } from '../contexts/DisplayPreferencesContext';

import NavigationBar from './NavigationBar';
import CatalogView from './CatalogView';
import ProductDetail from './ProductDetail';
import StoreDetail from './StoreDetail';
import GalleryPage from './GalleryPage';
import Footer from './Footer';
import CategoryDetail from './CategoryDetail';
import MaintenanceView from './MaintenanceView';

function AppContent() {
  const { isUnderMaintenance, maintenanceMessage } = useDisplayPreferences();

  if (isUnderMaintenance) {
    return <MaintenanceView message={maintenanceMessage} />;
  }

  return (
    <div
      style={{
        padding: '0px',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <NavigationBar />
      <div style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<CatalogView />} />
          <Route path="product/:slug" element={<ProductDetail />} />
          <Route path="category/:id" element={<CategoryDetail />} />
          <Route path="store" element={<StoreDetail />} />
          <Route path="browsedesigns" element={<GalleryPage />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <StoreProvider>
      <DisplayPreferencesProvider>
        <AppContent />
      </DisplayPreferencesProvider>
    </StoreProvider>
  );
}
